import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "roles-empty"
};
const _hoisted_2 = {
    key: 1,
    class: "roles-chips"
};
const _hoisted_3 = ["aria-label"];
const _hoisted_4 = {
    key: 0,
    "data-test": "role-overflow",
    class: "role-chip role-chip--overflow"
};
import { computed } from "vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'UserRolesCell',
    props: {
        roles: {},
        maxVisible: {}
    },
    setup(__props) {
        const props = __props;
        const max = computed(() => props.maxVisible ?? 2);
        const visibleRoles = computed(() => props.roles.slice(0, max.value));
        const overflowCount = computed(() => Math.max(0, props.roles.length - max.value));
        return (_ctx, _cache) => {
            return (__props.roles.length === 0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.$t("accessManager.users.roles.empty")), 1 /* TEXT */))
                : (_openBlock(), _createElementBlock("span", _hoisted_2, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleRoles.value, (role) => {
                        return (_openBlock(), _createElementBlock("span", {
                            key: `${role.type}-${role.id}`,
                            "data-test": "role-chip",
                            class: "role-chip",
                            "aria-label": role.name
                        }, _toDisplayString(role.name), 9 /* TEXT, PROPS */, _hoisted_3));
                    }), 128 /* KEYED_FRAGMENT */)),
                    (overflowCount.value > 0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_4, " +" + _toDisplayString(overflowCount.value), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true)
                ]));
        };
    }
});
